import { IStampLoyaltyReward } from 'features/cashier/services/types/stamp-loyalty';
import { formatRewardLabel } from './format-reward-label';
import { RewardsSection } from './styles';

type Props = {
  /** Toàn bộ mốc thưởng của shop, kể cả mốc khách chưa đạt */
  rewards: IStampLoyaltyReward[];
  /** Id các mốc khách đã đủ điều kiện nhận, lấy từ availableRewards */
  unlockedIds: Set<string>;
  /** Số stamp khách đang có, hiện ở mẫu số của mỗi dòng */
  totalStamp: number;
  selectedId: string | null;
  onSelect: (rewardId: string) => void;
};

/** Danh sách mốc thưởng của thẻ. Mốc đã mở khoá mới chọn để apply được. */
const RewardsAvailableList = ({ rewards, unlockedIds, totalStamp, selectedId, onSelect }: Props) => (
  <RewardsSection>
    <div className='rewards-heading'>
      <span className='rewards-title'>Rewards Available</span>
      <span className='rewards-hint'>Unlocked a reward to apply it</span>
    </div>

    <div className='rewards-list'>
      {rewards.map(reward => {
        const unlocked = unlockedIds.has(reward.id);
        const selected = reward.id === selectedId;
        return (
          <button
            type='button'
            key={reward.id}
            disabled={!unlocked}
            className={`reward-row ${selected ? 'selected' : ''} ${unlocked ? '' : 'locked'}`}
            onClick={() => onSelect(reward.id)}
          >
            <span className={`reward-radio ${selected ? 'checked' : ''}`}>
              {selected && <CheckIcon />}
            </span>
            <span className='reward-body'>
              <span className='reward-condition'>At {reward.stampsRequired} stamps</span>
              <span className='reward-label'>{formatRewardLabel(reward)}</span>
            </span>
            <span className='reward-progress'>{reward.stampsRequired}/{totalStamp}</span>
          </button>
        );
      })}
    </div>
  </RewardsSection>
);

export default RewardsAvailableList;

const CheckIcon = () => (
  <svg width='18' height='18' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 7.5L5.5 11L12 3.5' stroke='#FFFFFF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
